@import '../../../globals/main.scss';

pn-proxio-productcard-information {
  p.cardinfocontent-title {
    margin-bottom: 0.4rem;
  }

  p strong.cardinfocontent-label {
    font-size: 1.4rem;
    font-weight: 500;
  }
}
